export default {
  namespaced: true,

  state: () => ({
    roles: {
      data: [],
      links: {},
      meta: {},
    },
    role: {},
    isLoading: false,
  }),

  mutations: {
    SET_ROLES_LIST(state, payload) {
      state.roles = payload
    },
    SET_ROLE(state, payload) {
      state.role = payload
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
    RESET_ROLES_LIST(state) {
      state.roles = {
        data: [],
        links: {},
        meta: {},
      }
    },
  },

  actions: {
    search(_, payload) {
      return this._vm.$http.get('/v1/admin/roles', {
        params: {
          'filter[ids]': payload ? payload.ids : undefined,
          'filter[keyword]': payload ? payload.keyword : undefined,
        },
      })
        .then(({ data }) => data.data)
        .catch(() => [])
    },
    // get
    async getRolesList({ commit }, { page = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/roles?filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_ROLES_LIST', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    // show
    async getRole({ commit }, { id }) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/roles/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_ROLE', response.data.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    // delete
    async deleteRole({ commit, dispatch }, { rolesId }) {
      try {
        const url = `/v1/admin/roles/${rolesId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getRolesList')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Role!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Role!',
        }, { root: true })

        return error
      }
    },
    // create
    async createRole({ commit }, data) {
      try {
        const url = '/v1/admin/roles'

        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Role!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Role!',
        }, { root: true })

        return error
      }
    },
    // edit
    async updateRole({ commit }, { roleId, data }) {
      try {
        const url = `/v1/admin/roles/${roleId}`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Role!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Role!',
        }, { root: true })

        return error
      }
    },
    // add permission to role
    async addPermissionToRole({ commit }, { roleId, permissionId = null, action = '' }) {
      try {
        const url = `/v1/admin/sync-permission-to-role/${roleId}`

        const response = await this._vm.$http.post(url, {
          permission_id: permissionId,
          action,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Permission!',
        }, { root: true })

        return response.data.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Permission!',
        }, { root: true })

        return false
      }
    },
    // delete permission from role
    async deletePermissionFromRole({ commit }, { roleId, permissionId = null }) {
      try {
        const url = `/v1/admin/revoke-permission-to-role/${roleId}`

        const response = await this._vm.$http.post(url, {
          permission_id: permissionId,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Permission!',
        }, { root: true })

        return response.data.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Permission!',
        }, { root: true })

        return false
      }
    },
  },
}
